import axios from "axios"
axios.defaults.baseURL="http://192.168.88.228:8080/managerCloudOfficialWebsited"

//人数
export const getpeoples=()=>{
   return axios.get("StatisticalDisplay/queryResult")
}
